import React from "react";
import { Form, Select, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Controller } from "react-hook-form";
import PropTypes from "prop-types";

export default function ClinicSelectorField({
  control,
  errors,
  clinics,
  isClinicManager = false,
  onOpenCreateClinic,
}) {
  return (
    <Form.Item
      label="Clinique"
      required
      validateStatus={errors.clinicId ? "error" : ""}
      help={errors.clinicId?.message}
    >
      <div style={{ display: "flex", gap: 8 }}>
        <div style={{ flex: 1 }}>
          <Controller
            name="clinicId"
            control={control}
            rules={{ required: "La clinique est obligatoire" }}
            render={({ field }) => (
              <Select
                {...field}
                value={field.value}
                onChange={(v) => field.onChange(v)}
                placeholder="Sélectionner une clinique"
                showSearch
                optionFilterProp="label"
                disabled={isClinicManager && clinics.length === 1}
                options={clinics.map((c) => ({
                  value: c.id,
                  label: `${c.name} (${c.type || "AUTRE"})`,
                }))}
              />
            )}
          />
        </div>

        {!isClinicManager && (
          <Button icon={<PlusOutlined />} onClick={onOpenCreateClinic}>
            Ajouter
          </Button>
        )}
      </div>
    </Form.Item>
  );
}

ClinicSelectorField.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  clinics: PropTypes.arrayOf(PropTypes.object).isRequired,
  isClinicManager: PropTypes.bool,
  onOpenCreateClinic: PropTypes.func.isRequired,
};
